(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bess-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bess-filters]').forEach((filterGroup) => {
    const buttons = Array.from(filterGroup.querySelectorAll('button[data-filter]'));
    const grid = filterGroup.parentElement.querySelector('[data-bess-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-category]'));

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const selected = button.dataset.filter || 'all';
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const matches = selected === 'all' || card.dataset.category === selected;
          card.hidden = !matches;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
